// Utility helpers
export { cn } from './utils/cn';

// Custom SVG icon bank (supplements lucide-react in the CMS icon picker)
export { CUSTOM_ICONS } from './custom-icons';
export type { CustomIconComponent, CustomIconEntry, CustomIconProps } from './custom-icons';

// Material 3 primitives
export { Button } from './components/Button';
export type { ButtonProps, ButtonVariant, ButtonSize } from './components/Button';

export { IconButton } from './components/IconButton';
export type { IconButtonProps, IconButtonVariant, IconButtonSize } from './components/IconButton';

export {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from './components/Card';
export type { CardProps, CardVariant } from './components/Card';

export { Input } from './components/Input';
export { DynamicForm } from './components/DynamicForm';

export { Chip } from './components/Chip';
export type { ChipProps, ChipTone, ChipVariant } from './components/Chip';

export { Badge } from './components/Badge';
export type { BadgeProps, BadgeTone, BadgeVariant } from './components/Badge';

export { Avatar } from './components/Avatar';
export type { AvatarProps, AvatarSize } from './components/Avatar';

export { Skeleton, SkeletonText, SkeletonCard } from './components/Skeleton';
export type { SkeletonProps, SkeletonTextProps } from './components/Skeleton';

export { StatusPill } from './components/StatusPill';
export type { StatusPillProps, StatusKind } from './components/StatusPill';

export { EmptyState } from './components/EmptyState';
export type { EmptyStateProps } from './components/EmptyState';

export { Sheet, SheetHeader, SheetTitle, SheetBody, SheetFooter } from './components/Sheet';
export type { SheetProps, SheetSide } from './components/Sheet';

export { Pagination } from './components/Pagination';
export type { PaginationProps } from './components/Pagination';

// Panel primitives
export {
  PanelPage,
  PanelPageHeader,
  PanelSection,
  PanelSectionHeader,
  PanelToolbar,
  PanelKpiGrid,
  PanelKpiCard,
  PanelEmptyState,
  PanelNote,
  PanelDataList,
  PanelDivider,
} from './components/PanelPrimitives';
export type {
  PanelPageProps,
  PanelPageHeaderProps,
  PanelSectionProps,
  PanelSectionHeaderProps,
  PanelToolbarProps,
  PanelKpiGridProps,
  PanelKpiCardProps,
  PanelKpiTone,
  PanelEmptyStateProps,
  PanelNoteProps,
  PanelNoteTone,
  PanelDataListProps,
} from './components/PanelPrimitives';
